import React, { useMemo, useState } from "react";
import "./ProfileSetup.questionnaire-ui.css";

const STEP_OPTIONS = [
  "0-1,000",
  "1,000-2,500",
  "2,500-5,000",
  "5,000-7,500",
  "7,500-10,000",
  "10,000-12,500",
  "12,500 +",
  "I'm not sure!",
];

const ACTIVITY_OPTIONS = [
  "Sedentary (Office job, no exercise)",
  "Sedentary (Active job, no exercise)",
  "Light Exercise (1-2 days exercise or sport/week)",
  "Moderate Exercise (3-5 days exercise or sport/week)",
  "Heavy Exercise (6-7 days exercise or sport/week)",
  "Athlete (Train 2x per day)",
];

const WORKOUT_LOVE_OPTIONS = [
  "Strength/Resistance/Weight Training",
  "HIIT Cardio",
  "Jogging/Running",
  "Circuit Work",
  "Other",
];

const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

const TEXTAREA_NOTHING_FIELDS = [
  "current_exercise",
  "gym_experience",
  "health_conditions",
  "pain_notes",
  "active_hobbies",
  "eating_habits",
  "foods_love",
  "foods_hate_allergies",
  "fruits_veggies",
  "supplements",
  "yo_yo_diet",
];

const CHIP_FIELD_CONFIG = {
  dietary_restrictions: [
    "None",
    "Vegetarian",
    "Vegan",
    "Pescatarian",
    "Gluten-free",
    "Dairy-free",
    "Kosher",
    "Halal",
    "Low-sodium",
    "Low-carb",
  ],
  allergies: [
    "None",
    "Peanuts",
    "Tree nuts",
    "Dairy",
    "Eggs",
    "Shellfish",
    "Fish",
    "Soy",
    "Wheat",
    "Sesame",
  ],
  dislikes: [
    "None",
    "Broccoli",
    "Mushrooms",
    "Seafood",
    "Running",
    "Burpees",
    "Squats",
    "Overhead press",
    "Meal prep",
  ],
  medical_constraints: [
    "None",
    "Asthma",
    "High blood pressure",
    "Diabetes",
    "GERD",
    "High cholesterol",
    "Pregnant/postpartum",
    "Low-impact only",
  ],
  injury_constraints: [
    "None",
    "No running",
    "No jumping",
    "No overhead press",
    "No deep squats",
    "No deadlifts",
    "No twisting",
    "Low-impact only",
  ],
  equipment_available: [
    "Full gym access",
    "Dumbbells",
    "Barbell",
    "Bench",
    "Squat rack",
    "Cable machine",
    "Pull-up bar",
    "Resistance bands",
    "Kettlebells",
    "Treadmill",
    "Bike",
    "No equipment",
  ],
  forbidden_topics: [
    "None",
    "Fasting",
    "Keto",
    "Weight talk",
    "Scale talk",
    "Strict dieting",
    "Bodybuilding language",
    "Military tone",
  ],
};

const BODY_AREAS_FRONT = [
  { id: "front_head", label: "Head", x: 84, y: 20, w: 52, h: 32, rx: 16 },
  { id: "front_shoulders", label: "Shoulders", x: 56, y: 60, w: 108, h: 24, rx: 10 },
  { id: "front_chest", label: "Chest", x: 68, y: 88, w: 84, h: 38, rx: 12 },
  { id: "front_abs", label: "Abs", x: 78, y: 130, w: 64, h: 40, rx: 12 },
  { id: "front_left_arm", label: "Left arm", x: 24, y: 86, w: 28, h: 86, rx: 12 },
  { id: "front_right_arm", label: "Right arm", x: 168, y: 86, w: 28, h: 86, rx: 12 },
  { id: "front_hips", label: "Hips", x: 72, y: 176, w: 76, h: 28, rx: 12 },
  { id: "front_left_quad", label: "Left quad", x: 76, y: 208, w: 28, h: 72, rx: 12 },
  { id: "front_right_quad", label: "Right quad", x: 116, y: 208, w: 28, h: 72, rx: 12 },
  { id: "front_left_knee", label: "Left knee", x: 76, y: 286, w: 28, h: 20, rx: 8 },
  { id: "front_right_knee", label: "Right knee", x: 116, y: 286, w: 28, h: 20, rx: 8 },
  { id: "front_left_calf", label: "Left calf", x: 80, y: 312, w: 22, h: 62, rx: 10 },
  { id: "front_right_calf", label: "Right calf", x: 118, y: 312, w: 22, h: 62, rx: 10 },
  { id: "front_left_foot", label: "Left foot", x: 74, y: 380, w: 28, h: 14, rx: 6 },
  { id: "front_right_foot", label: "Right foot", x: 118, y: 380, w: 28, h: 14, rx: 6 },
];

const BODY_AREAS_BACK = [
  { id: "back_head", label: "Head", x: 84, y: 20, w: 52, h: 32, rx: 16 },
  { id: "back_upper_back", label: "Upper back", x: 68, y: 88, w: 84, h: 38, rx: 12 },
  { id: "back_lower_back", label: "Lower back", x: 78, y: 130, w: 64, h: 40, rx: 12 },
  { id: "back_glutes", label: "Glutes", x: 72, y: 176, w: 76, h: 28, rx: 12 },
  { id: "back_left_arm", label: "Left arm", x: 24, y: 86, w: 28, h: 86, rx: 12 },
  { id: "back_right_arm", label: "Right arm", x: 168, y: 86, w: 28, h: 86, rx: 12 },
  { id: "back_left_hamstring", label: "Left hamstring", x: 76, y: 208, w: 28, h: 72, rx: 12 },
  { id: "back_right_hamstring", label: "Right hamstring", x: 116, y: 208, w: 28, h: 72, rx: 12 },
  { id: "back_left_knee", label: "Left knee", x: 76, y: 286, w: 28, h: 20, rx: 8 },
  { id: "back_right_knee", label: "Right knee", x: 116, y: 286, w: 28, h: 20, rx: 8 },
  { id: "back_left_calf", label: "Left calf", x: 80, y: 312, w: 22, h: 62, rx: 10 },
  { id: "back_right_calf", label: "Right calf", x: 118, y: 312, w: 22, h: 62, rx: 10 },
  { id: "back_left_foot", label: "Left foot", x: 74, y: 380, w: 28, h: 14, rx: 6 },
  { id: "back_right_foot", label: "Right foot", x: 118, y: 380, w: 28, h: 14, rx: 6 },
];

function parseCSVOrText(value) {
  if (!value) return [];
  if (Array.isArray(value)) return value.filter(Boolean);
  return String(value)
    .split(",")
    .map((x) => x.trim())
    .filter(Boolean);
}

function serializeList(items) {
  return (items || []).filter(Boolean).join(", ");
}

function parseInjuryValue(value) {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function serializeInjuries(items) {
  return JSON.stringify(
    (items || []).map((item) => ({
      area: item.area,
      label: item.label,
      description: item.description || "",
    }))
  );
}

function ChipSelectField({
  name,
  label,
  options,
  value,
  onChange,
  required = false,
}) {
  const [selectedOption, setSelectedOption] = useState("");
  const [customValue, setCustomValue] = useState("");

  const addValue = (incoming) => {
    const v = String(incoming || "").trim();
    if (!v) return;
    if (/^none$/i.test(v)) {
      onChange(["None"]);
      return;
    }
    const deduped = (value || []).filter((item) => !/^none$/i.test(String(item)));
    if (deduped.some((item) => item.toLowerCase() === v.toLowerCase())) return;
    onChange([...deduped, v]);
  };

  const removeValue = (incoming) => {
    onChange((value || []).filter((item) => item !== incoming));
  };

  return (
    <div className="form-group">
      <label className="body-medium">{label}</label>
      <input type="hidden" name={name} value={serializeList(value)} required={required} readOnly />
      <div className="ps-chip-controls">
        <select
          className="form-input"
          value={selectedOption}
          onChange={(e) => setSelectedOption(e.target.value)}
        >
          <option value="">Select a common option…</option>
          {options.map((opt) => (
            <option key={opt} value={opt}>{opt}</option>
          ))}
        </select>
        <button
          type="button"
          className="btn-secondary"
          onClick={() => {
            addValue(selectedOption);
            setSelectedOption("");
          }}
        >
          Add
        </button>
      </div>

      <div className="ps-chip-controls" style={{ marginTop: 10 }}>
        <input
          className="form-input"
          value={customValue}
          onChange={(e) => setCustomValue(e.target.value)}
          placeholder="Or type your own"
        />
        <button
          type="button"
          className="btn-secondary"
          onClick={() => {
            addValue(customValue);
            setCustomValue("");
          }}
        >
          Add Custom
        </button>
      </div>

      {(value || []).length > 0 ? (
        <div className="ps-chip-list">
          {value.map((item) => (
            <button
              key={item}
              type="button"
              className="ps-chip"
              onClick={() => removeValue(item)}
              title="Remove"
            >
              {item} <span aria-hidden="true">✕</span>
            </button>
          ))}
        </div>
      ) : (
        <div className="body-small" style={{ color: "var(--text-muted)", marginTop: 8 }}>
          No selections yet.
        </div>
      )}
    </div>
  );
}

function BodyFigure({ title, areas, selectedMap, onToggle }) {
  return (
    <div className="ps-body-figure">
      <div className="body-small ps-body-figure-title">{title}</div>
      <svg viewBox="0 0 220 404" className="ps-body-svg" role="img" aria-label={title}>
        <rect x="84" y="20" width="52" height="32" rx="16" className="ps-body-base" />
        <rect x="56" y="60" width="108" height="24" rx="10" className="ps-body-base" />
        <rect x="68" y="88" width="84" height="118" rx="16" className="ps-body-base" />
        <rect x="24" y="86" width="28" height="86" rx="12" className="ps-body-base" />
        <rect x="168" y="86" width="28" height="86" rx="12" className="ps-body-base" />
        <rect x="76" y="208" width="28" height="98" rx="12" className="ps-body-base" />
        <rect x="116" y="208" width="28" height="98" rx="12" className="ps-body-base" />
        <rect x="80" y="312" width="22" height="62" rx="10" className="ps-body-base" />
        <rect x="118" y="312" width="22" height="62" rx="10" className="ps-body-base" />
        <rect x="74" y="380" width="28" height="14" rx="6" className="ps-body-base" />
        <rect x="118" y="380" width="28" height="14" rx="6" className="ps-body-base" />

        {areas.map((area) => {
          const selected = !!selectedMap[area.id];
          return (
            <rect
              key={area.id}
              x={area.x}
              y={area.y}
              width={area.w}
              height={area.h}
              rx={area.rx || 10}
              className={selected ? "ps-body-hit is-selected" : "ps-body-hit"}
              onClick={() => onToggle(area)}
            />
          );
        })}
      </svg>
    </div>
  );
}

function InjurySelectorField({ name, label, value, onChange }) {
  const [noneChecked, setNoneChecked] = useState(() => !value || value.length === 0);

  const selectedMap = useMemo(() => {
    const map = {};
    (value || []).forEach((item) => { map[item.area] = item; });
    return map;
  }, [value]);

  const toggleArea = (area) => {
    setNoneChecked(false);
    const existing = selectedMap[area.id];
    if (existing) {
      onChange((value || []).filter((item) => item.area !== area.id));
      return;
    }
    onChange([
      ...(value || []),
      { area: area.id, label: area.label, description: "" },
    ]);
  };

  const updateDescription = (areaId, description) => {
    onChange((value || []).map((item) => (
      item.area === areaId ? { ...item, description } : item
    )));
  };

  const clearAll = () => {
    setNoneChecked(true);
    onChange([]);
  };

  return (
    <div className="form-group">
      <label className="body-medium">{label}</label>
      <input type="hidden" name={name} value={serializeInjuries(value)} readOnly />
      <label className="body-small" style={{ display: "flex", gap: 10, alignItems: "center", margin: "8px 0 12px" }}>
        <input
          type="checkbox"
          checked={noneChecked}
          onChange={(e) => {
            const checked = e.target.checked;
            setNoneChecked(checked);
            if (checked) onChange([]);
          }}
        />
        No injuries to note
      </label>

      <div className="ps-body-grid">
        <BodyFigure title="Front" areas={BODY_AREAS_FRONT} selectedMap={selectedMap} onToggle={toggleArea} />
        <BodyFigure title="Back" areas={BODY_AREAS_BACK} selectedMap={selectedMap} onToggle={toggleArea} />
      </div>

      {(value || []).length > 0 ? (
        <div className="ps-injury-detail-list">
          {value.map((item) => (
            <div key={item.area} className="ps-injury-detail-card">
              <div className="ps-injury-detail-head">
                <div style={{ fontWeight: 800 }}>{item.label}</div>
                <button
                  type="button"
                  className="btn-secondary"
                  onClick={() => onChange((value || []).filter((x) => x.area !== item.area))}
                >
                  Remove
                </button>
              </div>
              <textarea
                className="form-input"
                rows={3}
                value={item.description || ""}
                onChange={(e) => updateDescription(item.area, e.target.value)}
                placeholder="Describe the injury, limitation, pain pattern, or surgery history…"
              />
            </div>
          ))}
        </div>
      ) : (
        <div className="body-small" style={{ color: "var(--text-muted)", marginTop: 10 }}>
          Tap muscles or body areas above to mark them red, then describe each injury below.
        </div>
      )}
    </div>
  );
}

function ProfileSetup({
  authUser,
  profile,
  onSave,
  onLogout,
  onClose,
  showClose = false,
  showToast,
}) {
  const [loading, setLoading] = useState(false);
  const [bloodworkMeta, setBloodworkMeta] = useState(null);
  const isEdit = !!profile;
  const qRequired = !isEdit;

  const defaults = useMemo(() => {
    const p = profile || {};
    const q = p.questionnaire || {};
    return {
      name: p.name ?? authUser?.name ?? "",
      age: p.age ?? "",
      gender: p.gender ?? "male",
      height_feet: p.height_feet ?? "",
      height_inches: p.height_inches ?? "",
      weight: p.weight ?? "",
      goal_weight: p.goal_weight ?? "",
      activity_level_label: p.activity_level_label ?? q.activity_level_label ?? ACTIVITY_OPTIONS[0],
      steps_range: q.steps_range ?? "I'm not sure!",
      current_exercise: q.current_exercise ?? "",
      gym_experience: q.gym_experience ?? "",
      workouts_love: Array.isArray(q.workouts_love) ? q.workouts_love : [],
      workouts_love_other: q.workouts_love_other ?? "",
      workouts_days_per_week: q.workouts_days_per_week ?? "3",
      preferred_workout_days: Array.isArray(q.preferred_workout_days) ? q.preferred_workout_days : [],
      health_conditions: q.health_conditions ?? "",
      current_injuries: parseInjuryValue(q.current_injuries),
      past_injuries: parseInjuryValue(q.past_injuries),
      pain_notes: q.pain_notes ?? "",
      active_hobbies: q.active_hobbies ?? "",
      eating_habits: q.eating_habits ?? "",
      foods_love: q.foods_love ?? "",
      foods_hate_allergies: q.foods_hate_allergies ?? "",
      fruits_veggies: q.fruits_veggies ?? "",
      supplements: q.supplements ?? "",
      yo_yo_diet: q.yo_yo_diet ?? "",
      dietary_restrictions: parseCSVOrText(q.dietary_restrictions),
      allergies: parseCSVOrText(q.allergies),
      dislikes: parseCSVOrText(q.dislikes),
      medical_constraints: parseCSVOrText(q.medical_constraints),
      injury_constraints: parseCSVOrText(q.injury_constraints),
      equipment_available: parseCSVOrText(q.equipment_available),
      forbidden_topics: parseCSVOrText(q.forbidden_topics),
      tracked_macros_before: q.tracked_macros_before ?? "No",
      smart_watch: q.smart_watch ?? "No",
    };
  }, [profile, authUser]);

  const [workoutsLoveHasOther, setWorkoutsLoveHasOther] = useState(() =>
    (defaults.workouts_love || []).includes("Other")
  );

  const [formValues, setFormValues] = useState(() => ({
    current_exercise: defaults.current_exercise,
    gym_experience: defaults.gym_experience,
    health_conditions: defaults.health_conditions,
    pain_notes: defaults.pain_notes,
    active_hobbies: defaults.active_hobbies,
    eating_habits: defaults.eating_habits,
    foods_love: defaults.foods_love,
    foods_hate_allergies: defaults.foods_hate_allergies,
    fruits_veggies: defaults.fruits_veggies,
    supplements: defaults.supplements,
    yo_yo_diet: defaults.yo_yo_diet,
  }));

  const [nothingSelected, setNothingSelected] = useState(() => {
    const obj = {};
    TEXTAREA_NOTHING_FIELDS.forEach((field) => {
      const value = defaults[field];
      obj[field] = !value || String(value).trim().toLowerCase() === "nothing";
    });
    return obj;
  });

  const [chipValues, setChipValues] = useState(() => ({
    dietary_restrictions: defaults.dietary_restrictions,
    allergies: defaults.allergies,
    dislikes: defaults.dislikes,
    medical_constraints: defaults.medical_constraints,
    injury_constraints: defaults.injury_constraints,
    equipment_available: defaults.equipment_available,
    forbidden_topics: defaults.forbidden_topics,
  }));

  const [injuryValues, setInjuryValues] = useState(() => ({
    current_injuries: defaults.current_injuries,
    past_injuries: defaults.past_injuries,
  }));

  const toggleFromArray = (arr, value) => {
    const set = new Set(arr);
    if (set.has(value)) set.delete(value);
    else set.add(value);
    return Array.from(set);
  };

  const handleTextFieldChange = (field, value) => {
    setFormValues((prev) => ({ ...prev, [field]: value }));
    if (value.trim()) {
      setNothingSelected((prev) => ({ ...prev, [field]: false }));
    }
  };

  const handleNothingToggle = (field, checked) => {
    setNothingSelected((prev) => ({ ...prev, [field]: checked }));
    setFormValues((prev) => ({
      ...prev,
      [field]: checked ? "NOTHING" : "",
    }));
  };

  const normalizeTextareaFieldsBeforeSubmit = (form) => {
    TEXTAREA_NOTHING_FIELDS.forEach((field) => {
      const input = form.elements.namedItem(field);
      if (!input) return;

      if (nothingSelected[field]) {
        input.value = "NOTHING";
      } else {
        const raw = formValues[field] ?? "";
        input.value = raw.trim() ? raw : "NOTHING";
      }
    });
  };

  const handleBloodworkFile = async (file) => {
    if (!file) {
      setBloodworkMeta(null);
      return;
    }

    const maxBytes = 2 * 1024 * 1024;
    if (file.size > maxBytes) {
      showToast?.(
        "Bloodwork file is too large for in-app storage. Please upload a smaller file (<= 2MB) or share externally.",
        "error"
      );
      return;
    }

    const toBase64 = (f) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(String(reader.result || ""));
        reader.onerror = reject;
        reader.readAsDataURL(f);
      });

    const dataUrl = await toBase64(file);
    const base64 = dataUrl.split("base64,")[1] || "";

    setBloodworkMeta({
      name: file.name,
      type: file.type || "application/octet-stream",
      data_base64: base64,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      normalizeTextareaFieldsBeforeSubmit(e.target);
      await onSave(e);
    } catch (error) {
      showToast?.("Error saving profile: " + (error?.message || String(error)), "error");
    }
    setLoading(false);
  };

  const renderTextareaWithNothing = (field, label, rows = 3, required = false) => (
    <div className="form-group">
      <label className="body-medium">{label}</label>

      <label className="body-small" style={{ display: "flex", gap: 10, alignItems: "center", margin: "8px 0" }}>
        <input
          type="checkbox"
          checked={!!nothingSelected[field]}
          onChange={(e) => handleNothingToggle(field, e.target.checked)}
        />
        Nothing
      </label>

      {nothingSelected[field] && <input type="hidden" name={field} value="NOTHING" />}

      <textarea
        name={nothingSelected[field] ? undefined : field}
        className="form-input"
        rows={rows}
        value={nothingSelected[field] ? "" : formValues[field]}
        onChange={(e) => handleTextFieldChange(field, e.target.value)}
        required={required && !nothingSelected[field]}
        disabled={nothingSelected[field]}
        placeholder={nothingSelected[field] ? "NOTHING will be saved" : ""}
      />
    </div>
  );

  return (
    <div className="app">
      <div className="container">
        <div className="profile-setup">
          <div className="ps-topbar">
            <div className="ps-title-row">
              <h1 className="heading-1" style={{ margin: 0 }}>
                {profile ? "Edit Profile" : "Create Profile"}
              </h1>

              {(showClose || isEdit) && (
                <button
                  type="button"
                  onClick={() => onClose?.()}
                  className="ps-close-btn"
                  aria-label="Close edit profile"
                  title="Close"
                >
                  ✕
                </button>
              )}
            </div>

            <div className="ps-topbar-actions">
              <button onClick={onLogout} className="btn-secondary" type="button">
                Logout
              </button>
            </div>
          </div>

          <div className="body-large" style={{ marginBottom: 24 }}>
            Client Health, Fitness & Nutrition Questionnaire
            <div className="body-small" style={{ color: "var(--text-muted)", marginTop: 6 }}>
              Please answer every question. If something doesn’t apply, use the <strong>Nothing</strong> checkbox.
            </div>
          </div>

          <form onSubmit={handleSubmit} className="profile-form">
            <input
              type="hidden"
              name="bloodwork_file_json"
              value={bloodworkMeta ? JSON.stringify(bloodworkMeta) : ""}
              readOnly
            />

            <input type="hidden" name="dietary_restrictions" value={serializeList(chipValues.dietary_restrictions)} readOnly />
            <input type="hidden" name="allergies" value={serializeList(chipValues.allergies)} readOnly />
            <input type="hidden" name="dislikes" value={serializeList(chipValues.dislikes)} readOnly />
            <input type="hidden" name="medical_constraints" value={serializeList(chipValues.medical_constraints)} readOnly />
            <input type="hidden" name="injury_constraints" value={serializeList(chipValues.injury_constraints)} readOnly />
            <input type="hidden" name="equipment_available" value={serializeList(chipValues.equipment_available)} readOnly />
            <input type="hidden" name="forbidden_topics" value={serializeList(chipValues.forbidden_topics)} readOnly />
            <input type="hidden" name="current_injuries" value={serializeInjuries(injuryValues.current_injuries)} readOnly />
            <input type="hidden" name="past_injuries" value={serializeInjuries(injuryValues.past_injuries)} readOnly />

            <h3 className="heading-4" style={{ marginBottom: 12 }}>Basics</h3>

            <div className="form-group">
              <label className="body-medium">First &amp; Last Name</label>
              <input type="text" name="name" required className="form-input" defaultValue={defaults.name} />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="body-medium">Age</label>
                <input type="number" name="age" required className="form-input" defaultValue={defaults.age} />
              </div>

              <div className="form-group">
                <label className="body-medium">Gender</label>
                <select name="gender" required className="form-input" defaultValue={defaults.gender}>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="other">Other / Prefer not to say</option>
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="body-medium">Height (ft)</label>
                <input type="number" name="height_feet" required className="form-input" defaultValue={defaults.height_feet} />
              </div>
              <div className="form-group">
                <label className="body-medium">Height (in)</label>
                <input type="number" name="height_inches" required className="form-input" defaultValue={defaults.height_inches} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="body-medium">Current Weight (lbs)</label>
                <input type="number" step="0.1" name="weight" required className="form-input" defaultValue={defaults.weight} />
                <div className="body-small" style={{ color: "var(--text-muted)", marginTop: 6 }}>
                  Weigh yourself in the morning after you pee &amp; before you eat.
                </div>
              </div>

              <div className="form-group">
                <label className="body-medium">Goal Weight (lbs)</label>
                <input type="number" step="0.1" name="goal_weight" className="form-input" defaultValue={defaults.goal_weight} />
              </div>
            </div>

            <div className="form-group">
              <label className="body-medium">What is your current physical activity level?</label>
              <select name="activity_level_label" required className="form-input" defaultValue={defaults.activity_level_label}>
                {ACTIVITY_OPTIONS.map((x) => (
                  <option key={x} value={x}>{x}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label className="body-medium">How many steps are you averaging daily right now?</label>
              <select name="steps_range" className="form-input" defaultValue={defaults.steps_range}>
                {STEP_OPTIONS.map((x) => (
                  <option key={x} value={x}>{x}</option>
                ))}
              </select>
            </div>

            <h3 className="heading-4" style={{ margin: "18px 0 12px" }}>Training</h3>

            {renderTextareaWithNothing(
              "current_exercise",
              "What are you currently doing for exercise/workouts?",
              3,
              qRequired
            )}

            {renderTextareaWithNothing(
              "gym_experience",
              "Have you worked out in a gym before? What experience have you tried?",
              3,
              qRequired
            )}

            <ChipSelectField
              name="equipment_available"
              label="Equipment available"
              options={CHIP_FIELD_CONFIG.equipment_available}
              value={chipValues.equipment_available}
              onChange={(next) => setChipValues((prev) => ({ ...prev, equipment_available: next }))}
              required={qRequired}
            />

            <div className="form-group">
              <label className="body-medium">What types of workouts do you LOVE?</label>
              <input type="hidden" name="workouts_love_json" defaultValue={JSON.stringify(defaults.workouts_love)} />
              <div style={{ display: "grid", gap: 8 }}>
                {WORKOUT_LOVE_OPTIONS.map((opt) => (
                  <label key={opt} className="body-small" style={{ display: "flex", gap: 10, alignItems: "center" }}>
                    <input
                      type="checkbox"
                      defaultChecked={defaults.workouts_love.includes(opt)}
                      onChange={(e) => {
                        const form = e.currentTarget.form;
                        const hidden = form.elements.namedItem("workouts_love_json");
                        const curr = JSON.parse(hidden.value || "[]");
                        const next = toggleFromArray(curr, opt);
                        hidden.value = JSON.stringify(next);
                        setWorkoutsLoveHasOther(next.includes("Other"));
                      }}
                    />
                    {opt}
                  </label>
                ))}
              </div>

              <div style={{ marginTop: 10 }}>
                <label className="body-medium">Other (only if "Other" is checked above)</label>
                <input
                  name="workouts_love_other"
                  className="form-input"
                  defaultValue={defaults.workouts_love_other}
                  disabled={!workoutsLoveHasOther}
                  placeholder={workoutsLoveHasOther ? "Describe the workout type..." : 'Check "Other" above to enable'}
                />
              </div>
            </div>

            <div className="form-group">
              <label className="body-medium">How many days per week can you do 45–60 minutes?</label>
              <select
                name="workouts_days_per_week"
                required={qRequired}
                className="form-input"
                defaultValue={defaults.workouts_days_per_week}
              >
                {["1", "2", "3", "4", "5", "6"].map((x) => (
                  <option key={x} value={x}>{x}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label className="body-medium">Which days do you prefer your workouts scheduled on?</label>
              <input type="hidden" name="preferred_workout_days_json" defaultValue={JSON.stringify(defaults.preferred_workout_days)} />
              <div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0,1fr))", gap: 8 }}>
                {DAYS.map((d) => (
                  <label key={d} className="body-small" style={{ display: "flex", gap: 10, alignItems: "center" }}>
                    <input
                      type="checkbox"
                      defaultChecked={defaults.preferred_workout_days.includes(d)}
                      onChange={(e) => {
                        const form = e.currentTarget.form;
                        const hidden = form.elements.namedItem("preferred_workout_days_json");
                        const curr = JSON.parse(hidden.value || "[]");
                        hidden.value = JSON.stringify(toggleFromArray(curr, d));
                      }}
                    />
                    {d}
                  </label>
                ))}
              </div>
            </div>

            <h3 className="heading-4" style={{ margin: "18px 0 12px" }}>Health & Injuries</h3>

            {renderTextareaWithNothing(
              "health_conditions",
              "Underlying health conditions (heart disease, BP, diabetes, asthma, etc.)",
              3,
              qRequired
            )}

            <ChipSelectField
              name="medical_constraints"
              label="Medical constraints"
              options={CHIP_FIELD_CONFIG.medical_constraints}
              value={chipValues.medical_constraints}
              onChange={(next) => setChipValues((prev) => ({ ...prev, medical_constraints: next }))}
              required={qRequired}
            />

            <ChipSelectField
              name="injury_constraints"
              label="Injury constraints"
              options={CHIP_FIELD_CONFIG.injury_constraints}
              value={chipValues.injury_constraints}
              onChange={(next) => setChipValues((prev) => ({ ...prev, injury_constraints: next }))}
              required={qRequired}
            />

            <InjurySelectorField
              name="current_injuries"
              label="Current injuries"
              value={injuryValues.current_injuries}
              onChange={(next) => setInjuryValues((prev) => ({ ...prev, current_injuries: next }))}
            />

            <InjurySelectorField
              name="past_injuries"
              label="Past injuries"
              value={injuryValues.past_injuries}
              onChange={(next) => setInjuryValues((prev) => ({ ...prev, past_injuries: next }))}
            />

            {renderTextareaWithNothing(
              "pain_notes",
              "Chronic/acute pain details (how long, what movements aggravate)",
              3,
              qRequired
            )}

            {renderTextareaWithNothing(
              "active_hobbies",
              "Active hobbies you enjoy or want to pick up again",
              3,
              qRequired
            )}

            <h3 className="heading-4" style={{ margin: "18px 0 12px" }}>Nutrition</h3>

            {renderTextareaWithNothing(
              "eating_habits",
              "Describe your current daily eating habits (detailed)",
              4,
              qRequired
            )}

            {renderTextareaWithNothing(
              "foods_love",
              "Foods you LOVE and can’t live without",
              3,
              qRequired
            )}

            {renderTextareaWithNothing(
              "foods_hate_allergies",
              "Foods you HATE / refuse (include allergies)",
              3,
              qRequired
            )}

            {renderTextareaWithNothing(
              "fruits_veggies",
              "Favorite fruits/veggies + servings per day",
              3,
              qRequired
            )}

            {renderTextareaWithNothing(
              "supplements",
              "Supplements currently taking",
              3,
              qRequired
            )}

            {renderTextareaWithNothing(
              "yo_yo_diet",
              "Yo-yo dieting / calorie restriction details",
              3,
              qRequired
            )}

            <ChipSelectField
              name="dietary_restrictions"
              label="Dietary restrictions"
              options={CHIP_FIELD_CONFIG.dietary_restrictions}
              value={chipValues.dietary_restrictions}
              onChange={(next) => setChipValues((prev) => ({ ...prev, dietary_restrictions: next }))}
              required={qRequired}
            />

            <ChipSelectField
              name="allergies"
              label="Allergies"
              options={CHIP_FIELD_CONFIG.allergies}
              value={chipValues.allergies}
              onChange={(next) => setChipValues((prev) => ({ ...prev, allergies: next }))}
              required={qRequired}
            />

            <ChipSelectField
              name="dislikes"
              label="Foods / activities you dislike"
              options={CHIP_FIELD_CONFIG.dislikes}
              value={chipValues.dislikes}
              onChange={(next) => setChipValues((prev) => ({ ...prev, dislikes: next }))}
              required={qRequired}
            />

            <ChipSelectField
              name="forbidden_topics"
              label="Forbidden topics for coaching"
              options={CHIP_FIELD_CONFIG.forbidden_topics}
              value={chipValues.forbidden_topics}
              onChange={(next) => setChipValues((prev) => ({ ...prev, forbidden_topics: next }))}
              required={qRequired}
            />

            <div className="form-row">
              <div className="form-group">
                <label className="body-medium">Tracked calories/macros before?</label>
                <select
                  name="tracked_macros_before"
                  className="form-input"
                  defaultValue={defaults.tracked_macros_before}
                  required={qRequired}
                >
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>

              <div className="form-group">
                <label className="body-medium">Apple/Samsung smartwatch?</label>
                <select
                  name="smart_watch"
                  className="form-input"
                  defaultValue={defaults.smart_watch}
                  required={qRequired}
                >
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
            </div>

            <h3 className="heading-4" style={{ margin: "18px 0 12px" }}>Bloodwork Upload</h3>
            <div className="form-group">
              <label className="body-medium">Upload bloodwork/metabolic panel (optional)</label>
              <input
                type="file"
                className="form-input"
                accept=".pdf,.png,.jpg,.jpeg,.webp"
                onChange={(e) => handleBloodworkFile(e.target.files?.[0] || null)}
              />
              {bloodworkMeta?.name && (
                <div className="body-small" style={{ marginTop: 8, color: "var(--text-muted)" }}>
                  Attached: {bloodworkMeta.name}
                </div>
              )}
            </div>

            <button type="submit" className="btn-primary" style={{ width: "100%" }} disabled={loading}>
              {loading ? "Saving..." : "Save Profile"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ProfileSetup;
